import { z } from 'zod'

export const ADMINAGENTSDELETE_CONTRACT_VERSION = '1.0.0' as const
export const adminAgentsDeleteResponseSchema = z.unknown()
export type AdminAgentsDeleteResponse = z.infer<typeof adminAgentsDeleteResponseSchema>
